import React from 'react';

export default class PageErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
        <div className="text-center max-w-sm">
          <p className="text-gray-700 mb-2">Something went wrong loading this page. Please refresh.</p>
          <p className="text-xs text-gray-400 break-words">{String(this.state.error?.message || this.state.error)}</p>
        </div>
      </div>
    );
  }
}